// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/transmision-cars/list',
    name: 'trasnmision-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/Transmision.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_transmision_cars',
    },
  },
]

export default formTable
